<template>
  <div class="box8">
    <pageTitle
      title="项目加持&nbsp;&nbsp;丰富AI开发经验"
      text="多领域多行业项目、打造AI核心竞争力，帮你积累<br />1-3年业务经验"
    />

    <div class="subject-content">
      <div class="title">
        <img src="../../../assets/coursePage/ai/box8/icon.png" alt />
        <p>AI项目覆盖领域</p>
        <img src="../../../assets/coursePage/ai/box8/icon.png" alt />
      </div>

      <div class="demo-box">
        <div class="demo" v-for="(item, index) in list" :key="index">
          <div class="demo-color">
            <div class="tit">{{ item.tit }}</div>
            <p v-html="item.p"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          :class="{ 'cur-nav': cur == index }"
          v-for="(item, index) in subject"
          :key="index"
          @click="changeCur(index)"
        >
          {{ item.tit }}
        </div>
      </div>

      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in subject"
          :key="index"
          :class="`slide${index}`"
        >
          <div
            class="block"
            ref="block"
            :style="
              `backgroundImage: url(` +
              require(`../../../assets/coursePage/ai/box8/${index + 1}.png`) +
              `)`
            "
          >
            <div class="open">
              查看全部
              <img src="../../../assets/coursePage/ai/box11/open.png" alt />
            </div>

            <div class="block-top">
              <div class="title">{{ item.nav }}</div>

              <div class="play-btn" v-if="item.video !== ''">
                <div class="play"></div>
                项目介绍
                <img
                  class="img1"
                  :class="{ rotateimg: showVideo }"
                  src="../../../assets/coursePage/ai/box8/arrow.png"
                  alt=""
                />
              </div>
            </div>
            <!-- {{ item.video }}-{{ showVideo }}-{{ cur }}-{{ index }}-{{ current }} -->
            <div
              v-if="
                item.video != '' &&
                showVideo &&
                (cur == index || current == index)
              "
              class="video-pop"
              :class="[
                item.video != '' && showVideo && cur == index ? '' : 'hidden',
              ]"
            >
              <div class="close-box" @click="close">
                <div></div>
              </div>
              <video
                id="video"
                class="video"
                controls="controls"
                :src="item.video"
                webkit-playsinline
                playsinline="true"
                type="video/mp4"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x-webkit-airplay="true"
                poster="../../../assets/coursePage/ai/box8/fenmain.png"
              ></video>
            </div>
            <div class="demo" v-show="item.demo.length !== 0">
              <p v-for="i in item.demo" :key="i">
                <span></span>
                {{ i }}
              </p>
            </div>
            <div class="into">{{ item.info }}</div>

            <div v-if="item.target.length !== 0">
              <div class="tag">学习目标</div>

              <div class="target targetSpecial">
                <p v-for="j in item.target" :key="j">{{ j }}</p>
              </div>
            </div>

            <div v-if="item.scheme.length !== 0">
              <div class="tag">解决方案</div>
              <div class="target">
                <p v-for="k in item.scheme" :key="k">{{ k }}</p>
              </div>
            </div>

            <div v-if="item.system.length !== 0">
              <div class="tag">课程体系</div>
              <div class="target">
                <p v-for="l in item.system" :key="l">{{ l }}</p>
              </div>
            </div>

            <!-- <div v-if="item.url !== ''">
              <div class="tag">技术架构</div>
              <img :src="item.url" alt />
            </div>-->
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box8"></div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      round
      :class="[cur == 2 ? 'special' : '']"
    >
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ subject[this.cur].nav }}</div>
          <!-- <div class="play-btn">
            <div class="play"></div>项目介绍
          </div>-->

          <div class="close" @click="show = false"></div>
        </div>
        <div class="demo" v-show="subject[this.cur].demo.length !== 0">
          <p v-for="i in subject[this.cur].demo" :key="i">
            <span></span>
            {{ i }}
          </p>
        </div>
        <div class="into">{{ subject[this.cur].info }}</div>

        <div v-if="subject[this.cur].target.length !== 0">
          <div class="tag">学习目标</div>
          <div class="target">
            <p v-for="j in subject[this.cur].target" :key="j">{{ j }}</p>
          </div>
        </div>

        <div v-if="subject[this.cur].scheme.length !== 0">
          <div class="tag">解决方案</div>
          <div class="target">
            <p v-for="k in subject[this.cur].scheme" :key="k">{{ k }}</p>
          </div>
        </div>

        <div v-if="subject[this.cur].system.length !== 0">
          <div class="tag">课程体系</div>
          <div class="target">
            <p v-for="l in subject[this.cur].system" :key="l">{{ l }}</p>
          </div>
        </div>

        <div v-if="subject[this.cur].url !== ''">
          <div class="tag">技术架构</div>
          <img
            style="width: 100%; padding-bottom: 64px"
            :src="subject[this.cur].url"
            alt
          />
        </div>
      </div>
    </van-popup>
    <!-- <div class="modal" v-if="showVideo ">
      <div class="video-pop">
 <div class="close-box" @click="close">
        <div></div>
        <img src="../../../assets/coursePage/ai/box8/video-close.png" alt />
      </div>
      <div class="video-box" v-if="showVideo">
           <video
          class="video"
          controls="controls"
          :src="src"
          autoplay="autoplay"
          type="video/mp4"
        preload="true"
          poster="../../../assets/coursePage/ai/box8/fenmain.png"
          webkit-playsinline="true"
          x5-video-player-type="h5"
          x5-video-orientation="portraint"
        ></video>
      </div>
      </div>
      
    </div> -->
    <!-- <van-popup v-model="showVideo" @close="close" class="video-pop">
      <div class="close-box" @click="close">
        <div></div>
        <img src="../../../assets/coursePage/ai/box8/video-close.png" alt />
      </div>
      <div class="video-box" v-if="showVideo">
        <video
          class="video"
          controls="controls"
          :src="src"
          autoplay="autoplay"
          webkit-playsinline
          playsinline="true"
          type="video/mp4"
          x5-video-player-type="h5" x5-video-player-fullscreen="true" x-webkit-airplay="true"
          poster="../../../assets/coursePage/ai/box8/fenmain.png"
        ></video>
          <video
                class="video"
                controls="controls"
                :src="src"
                poster="../../../assets/coursePage/ai/box8/fenmain.png"
                webkit-playsinline
                playsinline
              ></video>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,
      showVideo: false,
      src: "",
      cur2: 0,
      list: [
        {
          tit: "城市建设",
          p: "智慧城市&nbsp;&nbsp;自动驾驶",
        },
        {
          tit: "电商服务",
          p: "精准营销&nbsp;&nbsp;语义分析",
        },
        {
          tit: "医疗卫生",
          p: "智能问答&nbsp;&nbsp;AI医疗",
        },
        {
          tit: "安防监控",
          p: "险情检测&nbsp;&nbsp;人脸识别",
        },

        {
          tit: "金融证券",
          p: "牌价预测&nbsp;&nbsp;量化分析",
        },
        {
          tit: "智能制造",
          p: "姿态识别&nbsp;&nbsp;智能质检",
        },

        {
          tit: "媒体娱乐",
          p: "场景识别&nbsp;&nbsp;推荐系统",
        },
        {
          tit: "仓储物流",
          p: "供需预测  路线规划",
        },
      ],
      subject: [
        {
          tit: "项目一",
          nav: "美创医疗在线AI医生",
          info: "该项目结合医学知识图谱、深度学习、对话管理、微信公众号开发等技术，旨在降低首医成本，为患者提供基本医学诊断意见服务。技术层面包含语音识别、自然语言理解、对话管理以及自然语言生成等环节。",
          scheme: [],
          target: [
            "1. 掌握基于医疗知识图谱的实体检索技术",
            "2. 掌握基于Bert迁移学习的命名实体审核技术",
            "3. 掌握基于BiLSTM+CRF的命名实体识别技术",
            "4. 掌握基于微信公众号和Flask的模型部署服务",
            "5. 掌握基于语音识别与语音生成技术的与患者语音沟通的交互方式",
            "6. 掌握基于端到端以及结合知识库的多轮多任务对话系统网络结构",
            "7. 掌握数据清洗以及知识抽取、知识图谱构建",
            "8. 掌握基于图数据库Neo4j",
            "9. 掌握基于Mem2seq模型论文到代码实现",
          ],
          system: [],
          demo: [],
          url: require("../../../assets/coursePage/ai/box8/01.png"),
          video: "",
        },
        {
          tit: "项目二",
          nav: "智能文本分类系统",
          info: "智能文本分类系统是一款TOB类型的NLP领域基础设施类项目，用户可以通过文本分类， 解决智能推荐、营销等业务问题。它能够将各类非结构化文本进行正确分类，打上一个或多个适合的标签，帮助用户从业务角度进行数据分析。系统内包含很多NLP基础任务的处理方法。",
          scheme: [],
          target: [],
          system: [
            "第一章：背景介绍（1天）",
            "第二章：整体系统搭建（1天）",
            "第三章：构建标签词汇图谱（1天）",
            "第四章：特征工程与fasttext模型训练（1天）",
            "第五章：多模型训练与预测（1天）",
            "第六章：系统联调与测试（1天）",
            "第七章：项目实战练习测试（2天）",
          ],
          demo: ["5个解决方案", "2个优化方案", "8天授课天数"],
          url: require("../../../assets/coursePage/ai/box8/02.png"),
          video: "https://v.itheima.net/znwb10to.mp4",
        },
        {
          tit: "项目三",
          nav: "智慧交通",
          info: "智慧交通是一款智能交通辅助工具，包括轨迹估计模型、多目标跟踪、车道线检测等多项技术方案，能够为用户提供实时的交通路况信息，帮助交通管理者规划管理策略。",
          scheme: [],
          target: [],
          system: [
            "导学：背景介绍 项目环境搭建（1天）",
            "第一章：算法库介绍（2天）",
            "第二章：算法原理介绍（3天）",
            "第三章：多目标车辆检测（3天）",
            "第四章：车道线检测实现（2天）",
            "第五章：特定目标车辆跟踪（4天）",
          ],
          demo: [
            "90%验证集准确率",
            "85万数据集",
            "4个模型优化方案",
            "8天课程天数",
          ],
          url: require("../../../assets/coursePage/ai/box8/03.png"),
          video: "https://v.itheima.net/Ehx9QyJs.mp4",
        },
        {
          tit: "项目四",
          nav: "猫眼人脸支付CV项目",
          info: "人脸支付项目是基于计算机视觉方向的人脸识别项目，该项目以支付系统为背景介绍人脸处理整体流程。类似应用如办公打卡、智慧食堂、人脸考勤、嫌疑人识别等。",
          scheme: [
            "1. 视频中人脸检测的解决方案",
            "2. 人脸姿态（欧拉角）检测的解决方案",
            "3. 人脸关键点识别的解决方案",
            "4. 人脸多任务（年龄、性别等）检测的解决方案",
            "5. 人脸特征比对的解决方案",
          ],
          target: [
            "1. 基于深度学习，通过实时摄像头采集的视频数据，自动识别人脸并跟踪任务",
            "2. 基于目标检测和跟踪的人脸识别任务",
            "3. 基于端到端的人脸视频属性检测和人脸身份比对的目标识别系统",
            "4. 掌握基于机器学习和深度学习的人脸检测、人脸属性识别和人脸比对的整体流程",
            "5. 掌握人脸数据的特殊图像增强方式",
            "6. 掌握人脸数据库的构建、查询、删改等实现方法",
            "7. 掌握人脸项目的各个子任务集成方式",
            "8. 掌握基于仿射变换人脸矫正方法",
          ],
          system: [
            // "第一章：项目概述（0.5天）",
            // "第二章：环境部署（0.5天）",
            // "第三章：人脸识别项目流程方案（1天）",
            // "第四章：人脸识别核心技术（0.5天）",
            // "第五章：静态人脸识别系统（0.5天）",
            // "第六章：模型训练及测试（1天）",
            // "第七章：活体识别（1天）",
            // "第八章：人脸属性识别（1天）",
            // "第九章：模型联调与微调（1天）",
            // "练习测试：项目实战练习测试（1天）"
          ],
          demo: [
            // "98%验证集准确率",
            // "80万数据集",
            // "3个模型优化方案",
            // "8天课程天数"
          ],
          url: require("../../../assets/coursePage/ai/box8/04.png"),
          video: "",
        },
      ],
      cur: 0,
      current: 0,
      destructionVidel: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box8",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;

            that.showVideo = false;
            that.destructionVidel = false;
          },
          click(e) {
            if (
              e.target.className == "open" ||
              (that.$refs.block &&
                e.target.className != "play" &&
                e.target.className != "play-btn" &&
                e.target.className != "img1" &&
                e.target.className != "img1 rotateimg")
            ) {
              that.show = true;
            }

            if (
              e.target.className == "play" ||
              e.target.className == "play-btn" ||
              e.target.className == "img1" ||
              e.target.className == "img1 rotateimg"
            ) {
              that.showVideo = !that.showVideo;
              that.src = that.subject[that.cur].video;
              let dom = document.getElementById("video");
              that.mai("人工智能开发-AI就业课","项目介绍",0,that.subject[that.cur].nav)
              if (that.destructionVidel == false) {
                that.destructionVidel = true;
              } else {
                setTimeout(() => {
                  that.destructionVidel = false;
                }, 1000);
              }
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.cur = index;
      this.current = index;
      this.swiper.slideTo(index, 1000, false);

      this.showVideo = false;
    },
    close() {
      this.showVideo = false;
      this.src = "";
    },
  },
};
</script>

<style lang="less" scoped>
.box8 {
  padding: 80px 0 88px;

  width: 100%;
  .slide2 {
    .demo {
      justify-content: flex-start !important;
      p {
        margin-right: 60px;
      }
      p:nth-child(4) {
        margin-left: 15px;
      }
    }
  }
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .modal {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: skyblue;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 70;
  }
  .hidden {
    height: 0 !important;
  }
  .video-pop {
    background-color: transparent;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    width: 622px;
    position: relative;
    height: 352px;
    transition: all 1s;
    margin-bottom: 32px;
    // &::before {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   background: rgba(255, 255, 255, 0.2);
    //   z-index: 30;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    // }
    .close-box {
      top: 20px;
      right: 20px;
      position: absolute;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      z-index: 20;
    }
    img {
      // position: absolute;

      width: 32px;
      height: 32px;
      // background: #fff;
    }
  }

  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
  }

  background: linear-gradient(180deg, #dff8ff 0%, #fafdff 100%);
  .subject-content {
    margin: 0 auto;
    margin-top: 48px;
    margin-bottom: 80px;
    padding: 24px;
    width: 686px;
    height: 682px;
    background: linear-gradient(180deg, #d5f2ff 0%, #ffffff 100%);
    border-radius: 20px;
    border: 2px solid #fff;

    backdrop-filter: blur(7px);
    box-sizing: border-box;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      margin-bottom: 16px;
      width: 316px;
      img {
        width: 40px;
        height: 40px;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #4e5969;
        line-height: 44px;
        background: linear-gradient(270deg, #65adff 0%, #1fd7cd 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .demo-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 16px;
      .demo {
        margin-bottom: 18px;
        padding: 2px;
        width: 310px;
        height: 124px;

        border-radius: 16px;
        // border: 2px solid;
        background-image: linear-gradient(90deg, #eaf8fe 0%, #d0f0ff 100%);

        box-sizing: border-box;

        .demo-color {
          padding-top: 15px;
          padding-left: 47px;
          width: 306px;
          height: 120px;
          border-radius: 16px;
          background: #fff;
          box-sizing: border-box;
          p {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #86909c;
            line-height: 44px;
          }
        }

        .tit {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
          line-height: 44px;
        }
      }
    }
  }

  .subject-box {
    position: relative;
    margin: 0 auto;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;

    .nav-box {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      margin-bottom: 28px;
      width: 686px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;

      .nav {
        width: 138px;
        height: 68px;
        background: #ffffff;
        border-radius: 8px;
        text-align: center;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 68px;
      }

      .cur-nav {
        width: 138px;
        height: 68px;
        background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .swiper-slide {
    // padding: 0px 40px;
    padding-bottom: 38px;

    .block {
      position: relative;
      margin: 0 auto;
      padding: 32px 32px;
      width: 686px;
      height: 768px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
        height: 56px;
        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 200px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
          img {
            margin-left: 5px;
            transition: all 0.1s;
            width: 28px;
            height: 28px;
            object-fit: cover;
          }
        }
      }
      .rotateimg {
        transform: rotate(180deg);
      }
      .into {
        margin-bottom: 24px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        margin-top: 32px;
      }

      .demo {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;

        p {
          display: flex;
          align-items: center;

          span {
            margin-right: 8px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #00a8ff;
          }
        }
      }

      .tag {
        margin-top: 48px;
        margin-bottom: 24px;
        width: 144px;
        height: 48px;
        background: #e6f4ff;
        border-radius: 0px 32px 32px 24px;
        font-size: 26px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #00a8ff;
        line-height: 48px;
      }

      .target {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        p {
          margin-bottom: 12px;
        }
      }
    }
  }

  .swiper-pagination-box8 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }

  .block {
    position: relative;

    padding: 0px 48px;
    padding-top: 0px;

    background: #ffffff;

    border-radius: 20px;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;

      background: #fff;
      box-sizing: border-box;
      z-index: 50;
      align-items: center;
      height: 132px;
      padding-top: 16px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }

    .into {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
      padding-left: 0;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      margin-bottom: 32px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 32px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2674ff;
      line-height: 40px;
      line-height: 56px;
    }

    .target {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
      padding-left: 0;
      p {
        margin-bottom: 12px;
        padding-left: 32px;
        text-indent: -32px;
      }
    }
  }
  .targetSpecial {
    p:nth-child(1) {
      text-indent: -26px !important;
      padding-left: 26px !important;
    }
  }
  .special {
    .demo {
      justify-content: flex-start !important;
      p {
        margin-right: 60px;
      }
      p:nth-child(4) {
        margin-left: 15px;
      }
    }
  }
}
</style>
